import {useQuery} from '@apollo/react-hooks';

import type {GetSentBroadcastCount} from 'nutshell-graphql-types';

import GET_SENT_BROADCAST_COUNT from '../queries/get-sent-broadcast-count.graphql';

export const useGetSentBroadcastCount = (): {
    hasSentBroadcast: boolean;
    isLoading: boolean;
} => {
    const {data, loading} = useQuery<GetSentBroadcastCount>(GET_SENT_BROADCAST_COUNT, {
        fetchPolicy: 'cache-and-network',
    });

    return {
        hasSentBroadcast: (data?.broadcasts?.totalCount ?? 0) > 0,
        isLoading: loading,
    };
};
